<template>
  <legal-page
    title="Nuestros Servicios"
    :intro="`${business.name} es una empresa de telecomunicaciones que ofrece servicios de conectividad y entretenimiento para hogares y negocios en ${business.country}.`"
  >
    <div class="legal-services-grid">
      <div class="legal-service">
        <div class="legal-service-icon legal-service-icon--info">
          <feather-icon
            icon="WifiIcon"
            size="20"
          />
        </div>
        <div>
          <h3 class="legal-service-title">
            Internet de banda ancha
          </h3>
          <p class="legal-service-text">
            Planes de Internet residencial y empresarial con
            distintas velocidades, ideales para navegación, trabajo,
            estudio y streaming.
          </p>
        </div>
      </div>

      <div class="legal-service">
        <div class="legal-service-icon legal-service-icon--success">
          <feather-icon
            icon="TvIcon"
            size="20"
          />
        </div>
        <div>
          <h3 class="legal-service-title">
            Televisión por cable
          </h3>
          <p class="legal-service-text">
            Paquetes de canales nacionales e internacionales, con
            opciones de programación en alta definición.
          </p>
        </div>
      </div>

      <div class="legal-service">
        <div class="legal-service-icon legal-service-icon--warning">
          <feather-icon
            icon="PhoneIcon"
            size="20"
          />
        </div>
        <div>
          <h3 class="legal-service-title">
            Telefonía
          </h3>
          <p class="legal-service-text">
            Servicio de telefonía fija con planes de llamadas
            locales.
          </p>
        </div>
      </div>

      <div class="legal-service">
        <div class="legal-service-icon legal-service-icon--dark">
          <feather-icon
            icon="CreditCardIcon"
            size="20"
          />
        </div>
        <div>
          <h3 class="legal-service-title">
            Pago de facturas en línea
          </h3>
          <p class="legal-service-text">
            A través de este portal puedes consultar el balance de
            tu contrato y pagar tus facturas de forma segura con
            tarjeta de crédito o débito, en Pesos Dominicanos
            (RD$/DOP).
          </p>
        </div>
      </div>
    </div>
  </legal-page>
</template>

<script>
import business from "@/business"
import LegalPage from "./LegalPage.vue"

export default {
  components: { LegalPage },
  data() {
    return { business }
  },
}
</script>

<style lang="scss" scoped>
.legal-services-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 1rem;
}

.legal-service {
    display: flex;
    gap: 0.875rem;
    padding: 1.375rem;
    border: 1px solid var(--tm-border);
    border-radius: var(--tm-radius);
    background-color: var(--tm-surface);
}

.legal-service-icon {
    flex-shrink: 0;
    width: 40px;
    height: 40px;
    border-radius: var(--tm-radius-sm);
    display: flex;
    align-items: center;
    justify-content: center;

    &--info {
        background-color: rgba(var(--tm-info-rgb), var(--tm-tint));
        color: var(--tm-info);
    }

    &--success {
        background-color: rgba(var(--tm-success-rgb), var(--tm-tint));
        color: var(--tm-success);
    }

    &--warning {
        background-color: rgba(var(--tm-warning-rgb), var(--tm-tint));
        color: var(--tm-warning);
    }

    &--dark {
        background-color: rgba(var(--tm-primary-rgb), var(--tm-tint));
        color: var(--tm-primary);
    }
}

.legal-service-title {
    margin: 0 0 0.25rem;
    font-size: 0.9375rem;
    font-weight: 700;
    color: var(--tm-text);
}

.legal-service-text {
    margin: 0;
    font-size: 0.84375rem;
    color: var(--tm-text-secondary);
    line-height: 1.6;
}

@media (max-width: 576px) {
    .legal-services-grid {
        grid-template-columns: 1fr;
    }
}
</style>
